import styled from "styled-components";
import { CSSProperties } from "react";
import { Divider } from "antd";

export const buttonStyle = {
  display: "flex", // Habilita o uso de Flexbox
  justifyContent: "center", // Centraliza o texto horizontalmente
  alignItems: "center", // Centraliza o texto verticalmente
  width: "450px", // Ajuste de largura
  fontSize: "18px", // Tamanho da fonte
  padding: "12px 20px", // Aumento no tamanho vertical do botão
  backgroundColor: "rgb(0, 54, 68)",
  color: "#FFFFFF",
};
export const formStyle: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "1rem", // Espaçamento entre elementos
  padding: "2rem",
  margin: "2rem auto",
  maxWidth: "500px",
  width: "100%",
  backgroundColor: "#fff",
  border: "1px solid #ddd",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
};

export const btnStyle: CSSProperties = {
  marginTop: 20,
  borderWidth: "3px",
  borderRadius: "12px",
  backgroundColor: "rgb(0, 54, 68)",
  color: "#FFFFFF",
};

export const ContainerModal = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ItemTextModal = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #4a4a4a;
`;

export const TextModal = styled.p`
  font-size: 16px;
  color: #6d6d6d;
  font-weight: 500;
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  color: #333;
  margin-bottom: 10px;
`;

export const DividerStyled = styled(Divider)`
  margin: 8px 0;
  background-color: #e0e0e0;
`;
export const TitleIndex = styled.h1`
  font-size: 22px;
  font-weight: bold;
  color: rgb(0, 54, 68);
  margin-left: 15px;
`;
export const CheckBoxContainer = styled.div`
  width: 350px;
  height: auto;
  margin-left: 80px;
`;
export const ContainerModalArquivo = styled.div`
  margin: 15px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;`
export const ContainerModalAssinatura = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
